<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <div class="f-grid-ind">
          <div class="f-grid-col-ind" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
            <div class="ind-text">Công ty</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn công ty" :limit="company_obj.limit" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @keyup="emitEvent" @offset="changeOffset" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind" v-if="$store.getters.typeCompany !== 'contractor'">
            <div class="ind-text">Nhà thầu</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn" defaultLabel="label" :limit="contractor_obj.limit" :loading="contractor_obj.loading" v-model="contractor" :options="contractor_obj.items" :total="contractor_obj.total" @keyup="emitEventContractor" @offset="changeOffsetContractor" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind export-excel-col">
            <Button label="Xuất file excel" :loading="exporting_excel" :disabled="exporting_excel" @click="clickExportExcel()" />
          </div>
        </div>
        <BaseDatatable
          ref="datatable"
          :key="componentKey"
          :tableData="listData"
          :model="dataModel"
          :options="options"
          :filterDefault="filters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @onEventOptions="onEventOptions"
          @onDataChange="DataOnChange"
          :company="company"
          :company_id="company_id"
          :contractor="contractor"
        ></BaseDatatable>
        <Dialog
          header="Xuất file excel"
          :visible.sync="showExportDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Số lượng xuất vượt quá {{ export_limit }} dòng. Nếu muốn xuất file thì bấm tiếp tục hoặc bấm hủy để lọc lại và xuất file sau.
          <template #footer>
            <Button label="Hủy" @click="showExportDialog = false" icon="pi pi-times" class="p-button-warning callback-btn" />
            <Button label="Tiếp tục" @click="confirmExportExcel()" icon="pi pi-check" />
          </template>
        </Dialog>
        <Dialog
          style=""
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Toàn bộ dữ liệu đang có của người dùng sẽ bị xóa, bạn có chắc muốn xóa người dùng này không?
          <template
            #footer
          >
          <Button
          label="Hủy"
          @click="showDeleteDialog = false"
          icon="pi pi-times"
          class="p-button-warning callback-btn"
          />
          <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from './list'
import exportExcelList from '@/mixins/exportExcelList';
import DropdownScrollable from '@/components/DropdownScrollable';
export default {
  mixins: [exportExcelList],
  components: {
    BaseDatatable,
    DropdownScrollable
  },
  data() {
    return {
      export_api: '/_api/users',
      export_path: 'export_contractor_users',
      filters : {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      company: {},
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      department_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      company_id: null,
      contractor_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      contractor : null,
    }
  },
  // mounted () {
    
  // },
  async created() {
    this.initParams();
    // var a = 1;
    // if (a==1) {
    //   const token = this.$store.getters.token ? this.$store.getters.token : null
    //   if (token) {
    //     this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN_AUTH});
    //   } else {
    //     this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    //   }
    // } else {
      await this.getListCompany();
      console.log("this.$store.getters",this.$store.getters)
      this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
      this.modelName = this.$route.meta.model;
      // this.dataModel = DataServices.getModel(this.modelName);
      //console.log('this.dataModel:',this.dataModel);
      // this.title = this.dataModel.name
      this.$store.commit('setLoading', true);
      if(this.$route.params.reload) {
        window.location.reload();
      }
      if (!this.$commonFuction.isEmpty(this.$route.query)){
        console.log("this.$route.query.company_id", this.$route.query.company_id);
        if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
          this.company = {id: this.$route.query.company_id};
          setTimeout(() => {
            const query = Object.assign({}, this.$route.query);
            delete query.company_id;
            this.$router.replace({ query });
          }, 100);
        }
        if (!this.$commonFuction.isEmpty(this.$route.query.contractor_id)){
          // this.contractor = {id: this.$route.query.contractor_id};
          // setTimeout(() => {
            this.getDataContractor();
          // }, 500);
        }
      }
    // }
    // var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_BANNER);
    // if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
      
    // }
    // this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false:true;
    // this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;
    // this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false:true;
  },
  watch: {
    '$route': 'initParams',
    async 'company'() {
      await this.clearContractor()
      await this.getListDepartment();
      // if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
      //   this.company_id = this.company.id;
      // }
      // this.componentKey++;
      await this.getListContractor()
    },
    "company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company = {id: this.company_id};
        // this.getListContractor()
        // this.getListDepartment();
        // this.componentKey++;
      }
    },
    "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        // this.company = {id: this.company_id};
        // this.componentKey++;
      }
    },
  },
  methods: {
    emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.company_obj.offset = value;
      // this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.company_obj.offset > 0 ) {
            this.company_obj.items.push(...res.data.data.company);
          } else{
            this.company_obj.items = res.data.data.company;
          }
          this.company_obj.total = res.data.data.total;
          this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },

    async onEventOptions({event, key, data}) {
      console.log("key", key);
      console.log("event", event);
      if (key == "department") {
        console.log(data);
        this.department_obj = data;
        if (event == 'offset' || event == 'scroll') {
          await this.getListDepartment();
        }
      }
    },
    async getListDepartment() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.options["department"] = [];
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.department_obj.loading = true;
        if (!this.department_obj?.filters) {
          this.department_obj.filters = {};
        }
        this.department_obj.filters.company_id = this.company?.id;
        await ApiRepository.post("/_api/department/options", {filters: this.department_obj.filters, limit: this.department_obj.limit, offset: this.department_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.department_obj.offset > 0 ) {
            this.department_obj.items.push(...res.data.data.department);
          } else{
            this.department_obj.items = res.data.data.department;
          }
          this.department_obj.total = res.data.data.total;
          this.department_obj.loading = false;
          this.options["department"] = this.department_obj;
        }).catch((err) => {
            console.log(err);
            this.department_obj.loading = false;
        })
      }
    },
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = 'Danh sách nhân viên nhà thầu';
      // this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
      //   let dataUpdate = {}
      //   if(f.key == 'active'){
      //     dataUpdate['active'] = data[f.key]
      //   }
      //   let variables = {
      //     'data_update': dataUpdate,
      //     'where_key': {
      //       'id': {'_eq': data.id}
      //     }
      //   };
      //   this.$apollo.mutate({
      //     mutation: DataServices.updateData(this.modelName),
      //     variables: variables
      //   }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      if (that.$store.getters.controllers?.list_contractor_user) {
        if (that.$store.getters.controllers.list_contractor_user.includes("add")) {
          actions.header = {name: 'add', icon: 'plus', path: `list-contractor-user/add`};
        }
        // actions.header = { name: 'add', icon: 'plus'};
        actions.rows = function (rowData) {
          var buttons = {}
          //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
          if (that.$store.getters.controllers.list_contractor_user.includes("edit")) {
            buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-contractor-user/edit/`};
          }
          if (that.$store.getters.controllers.list_contractor_user.includes("delete")) {
            buttons.delete = {name: 'delete', icon: 'trash', key: 'id'};
          }
          if (that.dataModel.actions) {
            var modelaction = that.dataModel.actions(rowData)
            Object.assign(buttons, modelaction);
          }
          return buttons
        }
      }
      return actions
    },
    async callbackOptions() {
      this.dataModel.getDisplayFields();
      // var attributes = [];
      // for (let index = 0; index < fields.length; index++) {
      //   const element = fields[index];
      //   console.log(element.key);
      //   if (element.models !== undefined && element.models !== null) {
      //     // console.log("SDFGHJK",element)
      //     var optionsData = [];
      //     if( element['name']== "position"){
      //       // console.log("element",element)
            
      //     }
      //     // console.log("optionsData",optionsData)
      //     this.options[element.key] = optionsData;
      //   }
      //   this.componentKey++;
      // }

    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key]})
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString(), company_id: this.company_id }  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name_en
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path,query: { company_id: this.company_id }  })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'calculator':
          this.dialogMode = action.name
          this.$router.push({ path: action.path, query: { company_id: data.data[action.key] }  })
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async deleteData() {
      this.showDeleteDialog = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/users/delete", {user_id: that.deleteId}, {headers}).then(function () {
          that.componentKey += 1;
        }).catch((err) => {
          that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            })
        })
      }
    },
    emitEventContractor(keyword) {
      // console.log(keyword);
      this.$delete(this.contractor_obj.filters, 'filter_txt');
      if (keyword) {
        this.contractor_obj.filters.filter_txt = keyword;
      }
      this.getListContractor();
    },
    changeOffsetContractor(value) {
      this.contractor_obj.offset = value;
    },
    async getListContractor() {
      console.log("DAsdasdasdad")
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.contractor_obj.loading = true;
        await ApiRepository.post("/_api/contractor/options", {filters: this.contractor_obj.filters, limit: this.contractor_obj.limit, offset: this.contractor_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.contractor_obj.offset > 0 ) {
              this.contractor_obj.items.push(...res.data.data.contractor);
            } else{
              this.contractor_obj.items = res.data.data.contractor;
            }
            this.contractor_obj.total = res.data.data.count;
            this.contractor_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.contractor_obj.loading = false;
        })
      }
    },
    async clearContractor(){
      console.log("gọi clear")
      this.contractor_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.contractor = null
    },
    async getDataContractor(){
      if (this.$commonFuction.isEmpty(this.$route.query.contractor_id)) return;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        await ApiRepository.post("/_api/contractor/detail", {id: this.$route.query.contractor_id, company_id: this.company.id}, {headers}).then((res) => {
            if (res.data?.data) {
              var label = '['+res.data.data.code+'] '+res.data.data.name;
              this.contractor = {
                code: res.data.data.code,
                id: res.data.data.id, 
                name: res.data.data.name,
                label: label
              };
              // console.log("this.contractor",this.contractor);
            }
        }).catch((err) => {
            console.log(err);
        })
      }
    }
  },
  // apollo: {
  //   listData: {
  //     query() {
  //       this.modelName = this.$route.meta.model;
  //       return DataServices.getList(this.modelName);
  //     },
  //     variables () {
  //       // Use vue reactive properties here
  //       return this.whereKeyList;
  //     },
  //     update(data) {
  //       var listData = data[this.dataModel.tableName]
  //       this.title = this.dataModel.label + ' '
  //       this.dataModel.processData(listData)
  //       this.$store.commit('setLoading', false);
  //       this.componentKey += 1;
  //       return data[this.dataModel.tableName]
  //     },
  //     fetchPolicy: 'network-only',
  //     error() {
  //       this.$store.commit('setLoading', false);
  //     },
  //     skip() {
  //       return !this.modelName
  //     }
  //   }
  // }

}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-button-warning-o .p-button-label-o{
  color: #e95d57;
}
.p-button-warning .pi-times{
  color: #e95d57;
}
.f-grid-ind {
  display: flex;
  margin-left: -1rem;
  flex-flow: row wrap;
}
.f-grid-col-ind {
  width: 25% !important;
  padding: 0rem 0rem 0rem 1rem;
}
.ind-text { 
  font-weight: 600;
}
.idn-sel {
  margin-top: -6px;
}
.export-excel-col{
  margin-left: auto;
  align-self: flex-start;
  text-align: right;
  padding-right: 1rem;
}
</style>